import Asset from "./asset";

export interface DocumentVerificationItem {
  id?: number;
  verificationId?: number;
  documentId: number;
  documentName: string;
  categoryId?: number;
  verified: boolean;
  verificationDate?: string;
  expirationDate?: string;
  obs?: string;
  barcode?: string;
  assetName?: string;
  asset?: Asset;
  createdAt?: string;
  updatedAt?: string;
}

export interface DocumentVerification {
  id?: number;
  companyId?: number;
  assets?: Asset[];
  tripNumber?: string;
  date: string;
  userId: number;
  username: string;
  area?: string;
  items: DocumentVerificationItem[];
  createdAt?: string;
  updatedAt?: string;
}

export const newDocumentVerification = (): DocumentVerification => {
  return {
    date: new Date().toISOString(),
    userId: 0,
    username: "",
    items: [],
  };
};

export const newDocumentVerificationItem = (): DocumentVerificationItem => {
  return {
    documentId: 0,
    documentName: "",
    verified: false,
  };
};

export default DocumentVerification;
